export default {
  props: {
    /**
     * The input name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The file object.
     */
    value: {
      type: Object,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input is inside the form.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    imageRemove: {
      type: Function,
      required: false,
    },

  },

  methods: {
    /**
     * This method will be called whenever a the file input changes.
     *
     * @param  {Object} e    The event fired.
     */
    onFileChange(e) {
      const files = e;
      if (!files) {
        return;
      }
      this.$set(this.value, 'file', files);

      this.createImage(files);
    },

    /**
     * This method will be called to make the input file readable for the img tag.
     *
     * @param  {Object} file    The file object.
     */
    createImage(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$set(this.value, 'url', e.target.result);
      };

      reader.readAsDataURL(file);
      this.$emit('images-created', this.name, this.value);
    },

    /**
     * This method will be called to remove the image thumbnail and place the input back.
     *
     * @param  {Object} e    The event fired.
     */
    removeImage(e) {
      this.$confirm(this.$t('static.products.delete.imageConfirm'), this.$t('static.products.delete.title'), {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        // delete goes here...
        e.preventDefault();
        this.value.url = '';
        delete this.value.file;
        this.imageRemove();
      }).catch(() => {});
    },

    changeImage(e) {
      e.preventDefault();
      this.value.url = '';
      delete this.value.file;
      this.$emit('image-changed', this.name, this.value);
    },

    previewImage(e) {
      e.preventDefault();
      window.open(this.value.url, '_blank');
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  // eslint-disable-next-line
  render(h) {
    let input;
    if (!this.value.url) {
      input = (
        <div class="el-form-item">
          <el-upload drag action="#" beforeUpload={this.onFileChange}>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              {this.translation
                ? this.$t(`${this.translation}.placeholder`)
                : this.name}
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
        </div>
      );
    } else {
      input = (
        <div class="flex end wrap">
          <div class="imageWrapper" onClick={this.previewImage}>
              <img src={this.value.url || this.value.file} />
          </div>
          <div style="display:flex;flex-direction:column;">
          { this.imageRemove ?
            <el-button
              style="margin-left: 10px;"
              class="el-button--default small imageInputButton"
              onClick={this.removeImage}
            >
              {this.translation
                ? this.$t(`${this.translation}.removeImage`)
                : this.name}
            </el-button>
            : ''
          }
          <el-button
            class="el-button--default small imageInputButton"
            onClick={this.changeImage}
          >
            {this.translation
              ? this.$t(`${this.translation}.changeImage`)
              : this.name}
          </el-button>
          </div>
        </div>
      );
    }

    if (!this.insideForm) {
      return input;
    }

    let label = null;
    if (this.hasLabel) {
      label = this.translation
        ? this.$t(`${this.translation}.label`)
        : this.name;
    }

    return (
      <el-form-item error={this.error} label={label}>
        {input}
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/image/image.jsx